import { render } from "./brokerage-agent.vue?vue&type=template&id=5cfc8433"
import script from "./brokerage-agent.js?vue&type=script&lang=js"
export * from "./brokerage-agent.js?vue&type=script&lang=js"

import "./brokerage-agent.vue?vue&type=style&index=0&id=5cfc8433&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__